// One labeled entry per assignment setting a recorded flow implies. Labels
// come from the tasks.setting<Type> translations: a null value hides the step
// (several steps can collapse into one labeled setting, like time tracking),
// while a missing key renders the missing-key marker so new step types
// surface visibly instead of silently disappearing.
const taskFlowSettings = (flow, translate, resolveName) => (flow ?? [])
  .filter((step) => (
    // start and end are always recorded, so they announce no choice of their
    // own: only the pause the requester asked for makes them a timer
    (step.type !== 'start') || (flow.some((other) => (other.type === 'pause')))
  ))
  .map((step) => {
    const typeKey = `setting${step.type[0].toUpperCase()}${step.type.slice(1)}`;
    const label = translate(typeKey, 'tasks');
    if (label === null) return null;

    const actorRlid = step.rlid ?? ((['req', 'tgt'].includes(step.actor)) ? null : step.actor);
    const name = (actorRlid) ? resolveName?.(actorRlid) : null;

    return {
      type: step.type,
      opt: step.opt,
      label: (name) ? `${label} ${translate('by', 'tasks', undefined, false)} ${name}` : label,
    };
  })
  .filter(Boolean);

export default taskFlowSettings;
